import React, { useEffect, useState } from "react";
import { Form, Input, Button, Typography, Row, Col, Space, message, Card, Select } from "antd";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ArrowLeftOutlined, EditOutlined, SaveOutlined } from "@ant-design/icons";
import api from "../../API";
import dayjs from "dayjs";

function PackagesOA() {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const location = useLocation();
    const [options1, setOptions1] = useState([]);
    const [options2, setOptions2] = useState([]);
    const [defaultInfo, oaAccounts, packages] = location.state;

    useEffect(() => {
        setOptions1(packages.map((item, i) => ({ label: item.packageName, value: i })));
        setOptions2(oaAccounts.map((item, i) => ({ label: item.accountName, value: i })));
        if(defaultInfo){
            form.setFieldsValue({
                packageIndex: packages.findIndex(item => item.id === defaultInfo.package_id), 
                total_message: defaultInfo.total_message,
                OAAccountIndex: oaAccounts.findIndex(item => item.OAId === defaultInfo.OAId), 
                InvoiceNo: defaultInfo.InvoiceNo, 
                note: defaultInfo.note,

            })
        }
    }, []);

  const handleSubmit = async (values) => {
    try {
        const { packageIndex, OAAccountIndex, InvoiceNo, note, total_message } = values;
        const packageOA = {
            package_id: packages[packageIndex].id,
            OAId: oaAccounts[OAAccountIndex].OAId,
            total_message,
            InvoiceNo, 
            note,
            createdDate: defaultInfo? dayjs(new Date(defaultInfo.createdDate)).format("YYYY-MM-DD") :dayjs(new Date()).format("YYYY-MM-DD")
        }
        console.log(packageOA);
        const response = defaultInfo ? 
            await api.update_packageOAById(defaultInfo.id, packageOA) :
            await api.create_new_packageOA(packageOA);
        message.success(response.message);
        navigate('/packagesoa', { replace: true });
    } catch (error) {
        message.error(error.message)
    }
  };

  return (
    <Card 
        style={{ maxWidth: 800, margin: "0 auto", boxShadow: "1px 1px 5px #ccc", borderRadius: 10 }}
        title= {
        <Space align="center">
            <Link to="/packagesoa">
                <Button style={{width: 50}} icon={<ArrowLeftOutlined />} />
            </Link>
            <Typography.Title level={5} style={{margin: 0}}>
                {defaultInfo ? "Update" : "Create New"} Package OA
            </Typography.Title>
        </Space>
    }>
        <Form 
            form={form} 
            layout="vertical" 
            onFinish={handleSubmit}
            initialValues={{ isActive: 1 }}
        >
            <Row gutter={[16, 0]}>
                <Col xs={24} sm={12}>
                    <Form.Item label="Package Name" name="packageIndex" rules={[{ required: true, message: "Package Name cannot be empty" }]}>
                        <Select
                            popupMatchSelectWidth={false}
                            options={options1}
                            showSearch
                            filterOption={(input, option) =>
                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                            onChange={(selectedValue) => form.setFieldValue("total_message", packages[selectedValue].totalMessage) }
                            placeholder="Select Package Name"
                            style={{width:'100%'}}
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                    <Form.Item label="Total Messages" name="total_message" rules={[{ required: true, message: "Total messages cannot be empty" }]}>
                        <Input disabled variant="borderless" style={{color: "black"}}/>
                    </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                    <Form.Item label="OA Account" name="OAAccountIndex" rules={[{ required: true, message: "OA Account cannot be empty" }]}>
                        <Select
                            popupMatchSelectWidth={false}
                            options={options2}
                            showSearch
                            filterOption={(input, option) =>
                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                            placeholder="Select OA Account"
                            style={{width:'100%'}}
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                    <Form.Item label="Invoice Number" name="InvoiceNo" rules={[{ required: true, message: "Invoice cannot be empty" }]}>
                        <Input placeholder="Input invoice number"/>
                    </Form.Item>
                </Col>

                <Col span={24}>
                    <Form.Item label="Note" name="note">
                        <Input.TextArea rows={4} />
                    </Form.Item>
                </Col>
            </Row>

            <Form.Item style={{ textAlign: "center" }}>
                <Button type="primary" htmlType="submit" icon={defaultInfo? <EditOutlined/>: <SaveOutlined/>}>
                    {defaultInfo? "Update": "Save"}
                </Button>
            </Form.Item>
        </Form>
    </Card>
  );
}

export default PackagesOA
